import React from 'react';

import AddButton from '../../../../common/controls/AddButton';

const AddButtons: React.FC<any> = (props: any) => {
  const { handleAddRequest, handleAddDiscomfort, disabled } = props;

  return (
    <div className='flex ion-justify-content-end'>
      <AddButton
        disabled={disabled}
        label='ADD REQUEST'
        onClick={handleAddRequest}
      />
      <AddButton
        disabled={disabled}
        label='ADD DISCOMFORT'
        onClick={handleAddDiscomfort}
      />
    </div>
  );
};

export default AddButtons;
